import { render, staticRenderFns } from "./SeatAdd.vue?vue&type=template&id=2f9e4512&"
import script from "./SeatAdd.vue?vue&type=script&lang=js&"
export * from "./SeatAdd.vue?vue&type=script&lang=js&"
import style0 from "./SeatAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports